import { Stack, Typography } from '@mui/material'
import ReusableDialog from '../../common/reusableDialog'
import { MultiPaneItem } from '../../multiPane/multiPaneLayout.interface'
import { WidgetConfig } from '../widgetDashboard.interface'
import LayoutWireframe from './LayoutWireframe'

interface LayoutSlotPickerDialogProps {
    open: boolean
    panes: MultiPaneItem
    widgets: Record<number, WidgetConfig<any>>
    selectedSlotId: number | null
    onSelect: (slotId: number) => void
    onClose: () => void
    onConfirm: () => void
}

const LayoutSlotPickerDialog = ({
    open,
    panes,
    widgets,
    selectedSlotId,
    onSelect,
    onClose,
    onConfirm,
}: LayoutSlotPickerDialogProps) => (
    <ReusableDialog
        open={open}
        onClose={onClose}
        onSubmit={onConfirm}
        title="Add option chain to layout"
        submitText="Replace"
        submitButtonProps={{ disabled: selectedSlotId === null }}
        nonModal={false}
        content={(
            <Stack spacing={2}>
                <Typography variant="body2" color="text.secondary">
                    Select the widget you want to replace.
                </Typography>
                <LayoutWireframe
                    panes={panes}
                    widgets={widgets}
                    selectedSlotId={selectedSlotId}
                    onSelect={onSelect}
                />
            </Stack>
        )}
    />
)

export default LayoutSlotPickerDialog
